import { createTheme } from '@mui/material/styles';
import {isInIframe, isMobile} from "./utils.js";

const color = {
    black: '#1E1E1E',
    black2: '#424242',
    black3: '#757575',
    white: '#e7e7e7',
    gray: '#A9A9A9',
    mediumGray: '#363636',
    red: '#ff5347',
    green: '#6BCB77',
    blue: '#29b6f6',
    yellow: '#ffa726',
    secondary: '#3D86C9',
    // secondary: '#2196f3',
    paper: '#2B2B2B',
    background: '#1E1E1E',
    codeEditorPrimary: '#7a9bff'
}

const easy = {
    red: adjustColor(color.red),
    green: adjustColor(color.green),
    blue: adjustColor(color.blue),
    yellow: adjustColor(color.yellow),
}
export let colorBlack = color.black;

export let colorWhite = color.white;
export let colorRed = color.red;
export let colorGreen = color.green;
export let colorBlue = color.blue;
export let colorYellow = color.yellow;
export let colorEasyRed = easy.red;
export let colorEasyGreen = easy.green;
export let colorEasyBlue = easy.blue;
export let colorEasyYellow = easy.yellow;
export let colorSecondary = color.secondary;
export let colorGray = color.gray;
export let colorIcon = color.white;
export let colorText = color.white;
export let colorTextReverse = color.paper;
export let colorTextInactive = color.gray;
export let colorPaper = color.paper;
export let colorBox = color.mediumGray;
export let colorWarningBackground = color.paper;
export let intensePaper = color.paper;
export let logoText = color.white;
export let colorLogo = color.white;
export let colorLogoCenter = color.white;
export let errorColor = easy.red;
export let colorCodeEditorPrimary = color.codeEditorPrimary;

export let kbBackgroundOpacity, colorMain, colorMenuEdge, monacoTheme, backgroundColor, foregroundColor, colorLink, themeMode

export const updateColors = (mode) => {
    themeMode = mode;
    if (mode === 'dark') {
        const paper = isInIframe() ? '#1D2327' : color.paper;
        colorLink = '#7a9bff'
        colorRed = color.red;
        colorGreen = color.green;
        colorBlue = color.blue;
        colorYellow = color.yellow;
        colorEasyRed = easy.red;
        colorEasyGreen = easy.green;
        colorEasyBlue = easy.blue;
        colorEasyYellow = easy.yellow;
        colorSecondary = color.secondary;
        colorGray = color.gray;
        colorIcon = color.white;
        colorText = color.white;
        colorTextReverse = paper;
        colorTextInactive = color.gray;
        colorPaper = paper;
        colorBox = color.mediumGray;
        colorWarningBackground = paper;
        intensePaper = paper;
        logoText = color.white;
        colorLogo = color.white;
        colorLogoCenter = color.white;
        errorColor = easy.red;
        colorCodeEditorPrimary = color.codeEditorPrimary;
        backgroundColor = isInIframe() ? '#171B1E' : color.black;
        foregroundColor = color.white;
        kbBackgroundOpacity = 0.06;
        colorMain = color.white;
        colorMenuEdge = '#0E0E0E';
        monacoTheme = 'vs-dark'

        // light Theme
    } else {
        const myWhite = isInIframe() ? '#F0F0F1' : '#f5f5f5'; // handle WordPress White
        colorLink = '#6a8bef';
        colorRed = '#f44336';
        colorGreen = '#4caf50';
        colorBlue = '#2196f3';
        colorYellow = '#FFC107';
        colorEasyRed = adjustColor('#f44336');
        colorEasyGreen = adjustColor('#4caf50');
        colorEasyBlue = adjustColor('#2196f3');
        colorEasyYellow = adjustColor('#FFC107')
        // colorSecondary = '#2A6EBB';
        // colorSecondary = '#2196f3';
        colorGray = '#9e9e9e';
        colorIcon = color.black2;
        colorText = color.black2;
        colorTextReverse = color.white;
        colorTextInactive = color.black3;
        colorPaper = myWhite;
        colorBox = color.mediumGray;
        colorWarningBackground = color.paper;
        intensePaper = myWhite;
        logoText = color.black2;
        colorLogo = color.black2;
        colorLogoCenter = color.black2;
        // errorColor = easy.red; // not readable
        errorColor = adjustColor(colorRed,10,5);
        colorCodeEditorPrimary = '#3f51b5';
        backgroundColor = color.white;
        foregroundColor = color.black;
        kbBackgroundOpacity = 0.10;
        colorMain = color.black2;
        colorMenuEdge = myWhite;
        monacoTheme = 'vs'
    }
};

export const getTheme = (mode) => {
    updateColors(mode)
    return {
        palette: {
            mode: mode,
            primary: {
                main: colorMain,
            },
            success: {
                main: colorGreen,
            },
            info: {
                main: colorBlue,
            },
            error: {
                main: colorRed,
            },
            error2: {
                main: colorEasyRed,
            },
            warning: {
                main: colorYellow,
            },
            secondary: {
                main: colorSecondary,
            },
            background: {
                default: backgroundColor,
                paper: colorPaper,
            },
            text: {
                primary: colorText,
            }
        },
        // typography: {
        //     fontFamily: 'Open Sans, Arial, sans-serif', // Set Open Sans as the default font
        // },
        typography: {
            fontFamily: 'Lato, Arial, sans-serif', // Set Lato as the default font
        },
        components: {
            MuiTab: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiButtonBase: {
                defaultProps: {
                    // disableRipple: true
                }
            },
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: color.mediumGray
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: colorIcon,
                    },
                },
            },
            MuiTypography: {
                styleOverrides: {
                    root: {
                        color: colorText,
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderWidth: '1px',
                            },
                        },
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    head: {
                        color: colorText, // Ensure text color is consistent
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: { textTransform: 'none' },
                },
            },
        },
    }
}

// updateColors('light')

const theme = createTheme(getTheme());

export function hexToHSL(hex) {
    let r = parseInt(hex.slice(1, 3), 16) / 255;
    let g = parseInt(hex.slice(3, 5), 16) / 255;
    let b = parseInt(hex.slice(5, 7), 16) / 255;

    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0;
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    return [h * 360, s * 100, l * 100];
}

export function hslToHex(h, s, l) {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = n => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0'); // Конвертираме обратно в HEX
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}

export function adjustColor(hex, saturationDecrease = 20, lightnessIncrease = 10) {
    let [h, s, l] = hexToHSL(hex);
    s = Math.max(0, s - saturationDecrease);
    l = Math.min(100, l + lightnessIncrease);
    return hslToHex(h, s, l);
}

export const mobileButton = {
    width: (isMobile ? "100%" : "250px"), marginTop: '8px',
    textTransform: 'none',
};

export const styleSecondaryButton = {
    borderColor: "gray",
    color: "gray",
    '&:hover': {
        borderColor: color.white,
    },
};

export default theme;